module.exports = __webpack_public_path__ + "img/Pattern01.1a08c964.png";